import { useState } from 'react';
import AuthShell from '../../components/auth/AuthShell';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { MailCheck } from 'lucide-react';
import Loader2 from '@/components/brand/Loader2';

import { apiError } from '@/lib/apiError';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [resetLink, setResetLink] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      // Mientras el envío por email no está cableado, el backend puede devolver
      // el token (fuera de producción) para poder continuar el flujo.
      if (data?.reset_token) {
        setResetLink(`/reset-password?token=${data.reset_token}`);
      }
    } catch (error) {
      toast.error(apiError(error, 'No se pudo procesar la solicitud'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="w-full">

        {sent ? (
          <div className="space-y-6" data-testid="forgot-password-sent">
            <div className="flex items-center gap-3 text-primary">
              <MailCheck className="w-8 h-8" />
              <h1 className="font-display font-bold text-3xl text-white uppercase">REVISA TU CORREO</h1>
            </div>
            <p className="text-zinc-400 ">
              Si el correo está registrado, recibirás instrucciones para restablecer
              tu contraseña. El enlace expira en 60 minutos.
            </p>

            {resetLink && (
              <div className="rounded-sm border border-zinc-800 bg-zinc-900/50 p-4">
                <p className="text-zinc-500 text-xs mb-2 uppercase tracking-wider">
                  Modo prueba (email aún no activo)
                </p>
                <Link
                  to={resetLink}
                  className="text-primary hover:text-primary break-all text-sm"
                  data-testid="reset-link-dev"
                >
                  Continuar a restablecer contraseña →
                </Link>
              </div>
            )}

            <Link to="/login" className="block text-zinc-500 hover:text-zinc-300 text-sm ">
              ← Volver a iniciar sesión
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display font-bold text-3xl text-white uppercase text-center mb-2">Recuperar acceso</h1>
            <p className="text-zinc-400  mb-8">
              Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-zinc-300">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="tu@email.com"
                  className="input-default"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                />
              </div>

              <Button
                type="submit"
                className="btn-primary w-full"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    ENVIANDO...
                  </>
                ) : (
                  'ENVIAR INSTRUCCIONES'
                )}
              </Button>
            </form>

            <div className="mt-8 text-center">
              <Link to="/login" className="text-zinc-500 hover:text-zinc-300 text-sm ">
                ← Volver a iniciar sesión
              </Link>
            </div>
          </>
        )}
      </div>
    </AuthShell>
  );
};

export default ForgotPassword;
